module.exports = __webpack_public_path__ + "static/media/Avatars_Female_New-10.8ecfe184.jpg";